import { render, staticRenderFns } from "./CustomerLoans.vue?vue&type=template&id=9df5ca40"
import script from "./CustomerLoans.vue?vue&type=script&lang=js"
export * from "./CustomerLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports